import { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ISubtask } from "../../models/subtask";
import { Button, Table } from "semantic-ui-react";
import { Loading } from "../../components/Loading/Loading";
import { getSubtasks } from "../../services/calculationsService";
import { RAOReportState } from "../../store/raoReportReducer";
import { SubtaskRow } from "./SubtaskRow";
import "./Subtasks.css";

export const Subtasks = () => {
    const navigate = useNavigate();
    const params: { calculationId?: string; taskName?: string } = useParams();
    const [subtasks, setSubtasks] = useState<ISubtask[]>([]);
    const [loading, setLoading] = useState(false);
    const [reports, setReports] = useState(false);
    const [priority, setPriority] = useState(0);

    useEffect(() => {
        setLoading(true);
        getSubtasks(params.calculationId ?? "", params.taskName ?? "").then(res => {
            setSubtasks(res.items);
            const message = JSON.parse(res.items[0].message);
            const calcProps = message.CalcProps
                ? JSON.parse(message.CalcProps)
                : JSON.parse(message.calcProps);
            const jsonString = JSON.parse(calcProps.jsonString);
            setPriority(jsonString.priority);
            const raoReport: RAOReportState = jsonString.raoReport;
            if (raoReport.f299Secured !== 0 || raoReport.f299NonSecured) setReports(true);
            setLoading(false);
        });
    }, [params.calculationId, params.taskName]);

    return (
        <div id="subtasks-page-container" className="subtasks-page-container">
            <div id="subtasks-page-title tsc-blue" className="subtasks-page-title tsc-blue">
                <h1 id="subtasks-page-title">Calculation status</h1>
                <Button
                    id="button-subtasks-page-a"
                    primary
                    content="Back to list of tasks"
                    onClick={() => navigate(`/Calculations/${subtasks[0].parentGuid}/Tasks`)}
                />
            </div>
            <div id="subtasks-page-content">
                {loading ? (
                    <Loading />
                ) : (
                    <Table
                        id="table-subtasks-page-a"
                        striped
                        basic="very"
                        unstackable
                        textAlign="center"
                        className="subtasks-table"
                    >
                        <Table.Header id="table-header-subtasks-page">
                            <Table.Row id="table-row-subtasks-page">
                                <Table.HeaderCell id="table-headercell-subtasks-page-name">Name</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-done">Done</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-running">Running</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-priority">Priority</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-started">Started</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-finished">Finished</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-result">Result</Table.HeaderCell>
                                <Table.HeaderCell id="table-headercell-subtasks-page-a"></Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                        <Table.Body id="tableBody-subtasks-page">
                            {subtasks.map(s => (
                                <SubtaskRow
                                    key={s.id}
                                    subtask={s}
                                    reports={reports}
                                    priority={priority}
                                />
                            ))}
                        </Table.Body>
                    </Table>
                )}
            </div>
        </div>
    );
};
